var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-bar-form",class:{
    'chart-bar-form--rotated': _vm.rotated,
  },style:({
    height: _vm.width && _vm.width + 'px',
    width: _vm.height && _vm.height + 'px',
  })},[(!_vm.rotated || (_vm.width && _vm.height))?_c('apexchart',{attrs:{"width":_vm.height,"height":_vm.width,"type":"bar","series":_vm.series || _vm.seriesFromContent,"options":_vm.chartOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }